import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ALL_ON = {
  overview: true, timeline: true, activity: true, presentations: true, selections: true,
  decisions: true, documents: true, invoices: true, budget_summary: true,
};

/** Which portal sections this client may see at all, across their projects.
 *  Staff always get everything. The backend remains the authority; this only hides UI. */
export default function useClientSections() {
  const { isStaff, user } = useAuth();
  const [sections, setSections] = useState(ALL_ON);

  useEffect(() => {
    if (!user || isStaff) {
      setSections(ALL_ON);
      return;
    }
    api.get("/client/dashboard")
      .then((r) => setSections({ ...ALL_ON, ...(r.data.sections || {}) }))
      .catch(() => setSections(ALL_ON));
  }, [isStaff, user]);

  return sections;
}
